import React from "react";
import { useHistory } from "react-router-dom";
import ContentWrapper from "../../components/common/AssessmentContentWrapper";
import { routes } from "../../helper/routes";
import QuestionEditorForm from "./QuestionEditorForm";
import { QuestionEditorProvider } from "../../context/assessSections/QuestionEditorContext";

export default function CreateQuestionWithAssessmentPage() {
  const history = useHistory();

  const goBack = () => history.push(routes.ques_lib);

  return (
    <ContentWrapper>
      <QuestionEditorProvider includeAssessments>
        <QuestionEditorForm
        // Here assessment is made true
          title="Create Question with Assessment"
          withAssessment
          onBack={goBack}
          onCancel={goBack}
        />
      </QuestionEditorProvider>
    </ContentWrapper>
  );
}